import React from 'react';
import GatsbyImage from 'gatsby-image';
import './CommonServiceSection.scss';
import EuropeSvg from '../../static/img/europe.svg';

const CommonServiceSectionSmall = ({ data }) => null;

export default CommonServiceSectionSmall;
